import Vue from 'vue';

/**
 * Simple utility function to wrap an element with another one.
 * @param el Element to be wrapped
 * @param wrapper Wrapping element
 */
function wrap(el: Element, wrapper: HTMLElement) {
	el.parentNode?.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}

/**
 * Clone the first link in a given linklist to a new Node.
 * @param linkList List of links, from which the first entry should be cloned. Given as DIV element with anchors inside.
 * @returns Cloned first linklist entry or null, if there is none.
 */
function cloneFirstLink(linkList: Element): HTMLElement | null {
	const links = linkList.querySelectorAll('a');
	const firstLink = links.length && (links[0] as Node);
	if (firstLink) {
		return firstLink.cloneNode() as HTMLElement;
	}
	return null;
}

/**
 * Most teasers have both, a linklist and an image.
 * We want the image to perform as an additional link to the first link within the linklist.
 * Since the linklist is handed in via placeholder, we can't directly access its items.
 * Therefore, we have to "fish" for its first link with query selectors
 * and wrap the image with the corresponding anchor afterwards.
 */
function handleImageLink(el: HTMLElement) {
	// get both, a possible link list within the teaser
	// as well as a possible teaser image
	const linkList = el.querySelector('.olb-list');
	const teaserImage = el.querySelector('.olb-teaser-image');

	// if both, linklist and image are present and there isn't already an anchor within the image:
	// clone the anchor and wrap the image with it
	if (linkList && teaserImage && !teaserImage.querySelectorAll('a').length) {
		const anchor = cloneFirstLink(linkList);
		if (anchor) {
			// in order not to mistakenly style the image, we have to remove the anchor's classes
			anchor.removeAttribute('class');
			const teaserPicture = teaserImage.querySelector('picture');
			teaserPicture && wrap(teaserPicture, anchor);
		}
	}
}

export default Vue.directive('teaserlink', {
	bind(el) {
		handleImageLink(el);
	},
});
